const buildStructure = (permissionsAvailable, permissionsUsed) => {
	// Obtener permisos por modulo
	const getPermissionModule = module =>
		permissionsAvailable.filter(
			per => per.permission.split(".")[0] === module
		);

	// Obtener permisos de un modulo
	const loadPermissions = module =>
		getPermissionModule(module).map(per => ({
			description: per.description,
			permission: per.permission,
			active: checkPermissionUsed(per.permission)
		}));

	// Verificar si un permiso es usado
	const checkPermissionUsed = permission =>
		permissionsUsed.find(per => per === permission) ? true : false;


	// Helper para construir una plantilla de permisos
	// recibo un titulo, y el modulo a construir
	const buildModule = (title, module) => ({
		module: title,
		permissions: loadPermissions(module),
		expand: true,
		active: false
	});

	return [
		buildModule("Tiempo real", "realtime"),
		buildModule("Operacion", "operation"),
		buildModule("Reservas", "reservation"),
		buildModule("Coordinacion", "coordination"),
		{
			module: "Tarifas",
			active: false,
			expand: true,
			children: [
				{
					module: "Planes tarifarios",
					active: false,
					expand: true,
					children: [
						buildModule("Planes tarifarios", "rates"),
						buildModule("Precios", "prices")
					]
				},
				buildModule("Cotizador", "quote"),
				buildModule("Cotizador de vuelos", "flightCalculator"),
				{
					module: "Puntos de venta",
					expand: true,
					active: false,
					children: [
						buildModule("General", "pointOfSale"),
						buildModule("Settings", "settings"),
						buildModule(
							"Monedas y tipo de cambio",
							"currentExchangeRate"
						)
					]
				},
				buildModule("Costos de proveedor", "supplierCost"),
				buildModule("Costos de canal de venta", "saleChannelCost")
			]
		},
		{
			module: "Configuraciones",
			expand: true,
			active: false,
			children: [
				buildModule("Ciudades", "city"),
				buildModule("Razones de Estado", "reasonState"),
				buildModule("Destinos", "place"),
				buildModule("Aeropuertos", "airport"),
				buildModule("Canales", "channel"),
				buildModule("Proveedores", "supplier"),
				buildModule("Categorias de tipos de servicios", "serviceTypesCategories"),
				buildModule("Tipo de servicio", "serviceType"),
				buildModule("Servicios adicionales", "additionalService"),
				{
					module: "Zonas",
					expand: true,
					active: false,
					children: [
						buildModule("Zonas", "zone"),
						buildModule("Zonas de operacion", "zoneArea")
					]
				},
				buildModule("Historial de cambios", "changelog"),
				buildModule("Cierre de ventas", "stopSale"),
				buildModule("Mapeo", "mapping"),
				{
					module: "Usuarios",
					expand: true,
					active: false,
					children: [
						buildModule("Usuarios general", "user"),
						buildModule("Usuarios SASS", "usersass")
					]
				},
				buildModule("Perfiles", "profile")
			]
		},
		{
			module: "Reportes",
			expand: true,
			active: false,
			children: [
				buildModule("Reportes", "report"),
				buildModule("Dashboard", "dashboard")
			]
		},
		{
			module: "Promociones",
			expand: true,
			active: false,
			children: [
				buildModule("Proveedores", "promotion"),
			]
		},
		buildModule('Vuelos', 'flight'),
		buildModule('Importar', 'reservations'),
		buildModule("Filtros", "filters")
	];
};

// Para no tener que iterar los permisos en cada check,
// se construye un objeto en el cual directamente se verifica un permiso por key
// Ejemplo:
// 		Para buscar el permiso de "city.show" no se va a iterar la lista de permisos,
//		si no que directamente se obtendra el permiso en base al key "user.permissions.city_show"
const buildUserPermissionObject = (userPermissions) => userPermissions.reduce((acc,curr)=> ({...acc, [curr.split('.').join('_')]: true }),{})

// Construir un objeto de los modulos
const buildUserModuleObject = (userPermissions) => userPermissions.reduce((acc,curr)=> ({...acc, [curr.split('.')[0]]: true }),{})


export default { buildStructure, buildUserPermissionObject, buildUserModuleObject };
